<app-admin-invite-sidebar></app-admin-invite-sidebar>
<div id="main" tabindex="-1">

  <div class="content page">
    <div class="head dimable">
      <h1 class="invite-users-title" i18n="This is the meaning of invite users|This is the description about invite users@@invitePageTitle">Invite
        Users</h1>
    </div>
    <div class="container-fluid">
      <div class="row col-lg-8">
        <div class="explanation">
          <span
            i18n="Setting up users|Description text saying how to setup users within you're institution@@inviteDescriptionText">To setup users in your institution with access to  EndNote Fusion, enter their email addresses below, either directly, or by uploading a text file. EndNote Fusion will send out emails with unique signup codes and instructions that allow your users to create account for themselves.</span>
        </div>
      </div>
      <form class="invite" name="inviteForm" #inviteForm="ngForm" enctype="multipart/form-data">
        <div class="row">
          <div class="col-md-12">
            <div *ngIf="inviteStatusBox.message.length > 0">
              <div class="inviteStatusBox" [ngClass]="inviteStatusBox.status">
                <i class="glyphicon" [ngClass]="inviteStatusBox.status === 'success' ? 'glyphicon-ok-sign' : 'glyphicon-exclamation-sign'"></i>
                <p>{{ inviteStatusBox.message }}</p>
              </div>
            </div>
            <div class="form-group">
              <h3 i18n="Section Heading|This is the description about invite users@@inviteUsersSectionHeading">Users to
                invite</h3>
              <label for="email_list"
                     i18n="Email addresses to be entered|List of email addresses entered by the user@@inviteUsersEmailAddressLabel">Enter
                email addresses, separated by commas or semicolons:</label>
              <input class="form-control" id="email_list" type="textarea" [(ngModel)]="email_list" name="email_list"
                     i18n-placeholder="Email Address Placeholder|Placeholder text showing the user an example email address@@inviteEmailAddressPlaceholder"
                     placeholder="email.address@domain.edu, email.address@domain.edu"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="file"><strong i18n="or|or@@inviteOrText">or </strong> <span
                i18n="Upload Text File|Users uploads a text file@@inviteFileUploadLabel">upload a text file containing one email address per line:</span></label>
              <input class="form-control" #fileupload id="file" [(ngModel)]="fileName" (change)="fileChange($event)"
                     type="file" name="fileName"/>
            </div>
          </div>
        </div>
        <div class="row email">
          <div class="col-md-12">
            <div class="form-group">
              <h3 i18n="Personal Message|Heading for entering a message@@invitePersonalMessageHeading">Your personal
                message</h3>
              <div class="explain" i18n="Email Preview title|Email preview title@@invitePersonalMessageSubHeading">All
                invited users will receive an email like this:
              </div>
              <textarea class="form-control message" (change)="onTextarea1Change($event)" id="emailMSG1" type="textarea"
                        #emailMSG1DOM name="emailMSG1">{{ emailMSG1 }}</textarea>
              <div class="uneditable">
                <p><span
                  i18n="Accepting Invitation|The preview of how the invitation will appear to the user@@invitePreviewInvitationText">To continue, click or copy/paste this link:</span><br/>
                  << UNIQUE INVITATION URL >></p>
              </div>
              <textarea (change)="onTextarea2Change($event)" class="form-control message lower" id="emailMSG2"
                        type="textarea" #emailMSG2DOM name="emailMSG2">{{ emailMSG2 }}</textarea>
            </div>
          </div>
          <div class="form-group">
            <button i18n="Invite Users Button|The button to submit the form@@inviteInviteUsersButton"
                    class="btn btn-primary" (click)="onSubmit(inviteForm)">Invite Users
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
